export const ERROR_ACCOUNT_NOT_ENOUGH_BALANCE = 301;
export const ERROR_DRAW_NOT_FOUND = 302;
export const ERROR_DRAW_EXPIRE = 303;
export const ERROR_BETTING_LO_STOPPED = 304;
export const ERROR_BETTING_POST_STOPPED = 305;
export const ERROR_USER_HAS_NO_LOTTERY = 306;
export const ERROR_A_HAS_STOPPED = 307;